<div
  id="sectionId_team"
  *transloco="let t"
  class="sectionId_team sectionAnchor flexBoxOuter"
  style="padding: 50px 20px; background: #e8e8e8"
>
  <div class="flexBoxInnerWider txt marginRight" style="hyphens: auto">
    <div style="margin-bottom: 26px">
      <h4 data-translate="start.quickNav.team">{{ t("products.start.quickNav.team") }}</h4>
    </div>
    <div class="kw-team-row">
      @for (member of teamMembers; track member.id) {
        <div class="kw-team-card">
          <div class="cImage kw-team-img-container">
            <img style="object-position: center" class="kv-team-img" [src]="member.imageSrc" [alt]="member.imageAlt" />
          </div>
          <div class="kw-team-text">
            <span class="kw-team-text-name">{{ member.name }}</span>
            <div>
              <span>{{ t(member.role) }}</span>
              @if (member.secondRole) {
                <span>, {{ t(member.secondRole) }}</span>
              }
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>
